import React,{ PureComponent, } from 'react'
import {Form, Input, InputNumber, DatePicker, Checkbox, Radio, Select, Spin} from 'antd';
import PropTypes from 'prop-types';
import UploadFile from '@components/UploadFile/UploadFile';
import UploadImage from '@components/UploadFile/UploadImage/UploadImage';
import UploadFileIcon  from '@components/UploadFile/UploadImage/UploadFileIcon';
import ViewImage from '@components/UploadFile/UploadImage/ViewImage';
import SearchSelector from '@components/SearchSelector/SearchSelector';
import CommonSelect from './CommonSelect';
import Lang from "@/components/Lang/Lang";
import BtnSelect from '../BtnSelect/BtnSelect';
import Locale from "@utils/locale";
import {trim,isEmpty,isEmptyObject} from '@utils/utils';
import TelephoneCode from "@/components/TelephoneCode/TelephoneCode";
import Region from '@/components/Region/Region';
import City from '@/components/Region/City/index';
import TransitCity from "@/components/Region/TransitCity";
import CategorySelector from "../CategorySelector/CategorySelector";
import './index.less';
const FormComponent = Form;
const FormItem = FormComponent.Item;
const { TextArea } = Input;
const {  RangePicker } = DatePicker;
const Option = Select.Option;

/**
 * 格式化表单 //todo 日间选择选择未处理是否格式化时间戳 ，以及编辑时 读取搜索下拉组件问题未处理， V2.0 todo
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * 必传字段
 * options 选项内容  [{
     * name:'返回的Key',
     * cnTitle 国际化显示文字，默认值，优选 **
     * cnTitleID 国际化KEY值
     * required: 是否必填，默认false
     * disabled:true不可编辑,
     * hidden:true隐藏,
    * type 默认 普通 Input , 配置pattern[],正则内容
                     Number：数字类型, 配置： numConfig 对象 -设置最小度，数值精度等 {min:1,precision: 0} ，addonAfter- 后缀
                     DateRangePicker: 时间选择范围类型,
                     Date日期选择控件, disabledDate 配置不可选择日期
                     SearchSelector:传API接口的搜索选择器, 多功能，有搜索按钮
                     SearchSelect: 传API接口的搜索下拉，
                     Select||CountrySelect: 传list 下拉选择
                     Enum：枚举(配置enumList读取List,配置enumClass读取字典), 可配置 change，回调选中数据
                     Radio：单选组(读取options或者radioClass字典),可配置 change，回调选中数据
                     Text: 显示文本
                     TextArea：多行文本框,minRows 配置最小行
                     UploadFile：上传文件
                     UploadImage：上传图片，可配置上传样式：'avatar':头像样式，'RU_IDcard':俄罗斯身份证示例样式
                     UploadFileIcon: 上传文件 ，显示后缀图标
                     ViewImage：查看图片
                     Checkbox：多选
                     Region：区域
                     Email：邮件
                     OnlyRender：只是渲染,可配置 1. showTitle 为true显示标题，2.onlyRender.渲染项
                     AreaPhone：区号+手机, 配置 nameTelephoneCode 区号回传值，默认telCode, addonAfter/suffix:配置后缀
                     City: 城市组件，多选 回调城市数组
                     BtnSelect:按钮样式选择
 * }]
 * getFormValue 保存动作：获取表单数据回调
 *
 * 可选 参数：
 * initialValues: 打开默认值
 * formItemLayout 可配置样式，Obj,
 * formLayout     配置 排版：默认 水平，
 *
 *
 **/
class FormFormat extends PureComponent {
    static propTypes = {
        options: PropTypes.array.isRequired,
        getFormValue: PropTypes.func,
        enumClass: PropTypes.string,
        searchClass: PropTypes.object,
        disabledLessThanBeforeToday: PropTypes.bool,
        formItemLayout: PropTypes.object,
        formLayout:PropTypes.string,
        className:PropTypes.string,
        initialValues: PropTypes.object, //默认值
    }
    static defaultProps = {
        flagLessThanBeforeToday: false,
        formLayout: 'horizontal', // horizontal 水平 vertical  垂直模式
        size: 'large',
        className:null,
        formItemLayout:null,
        name:"basic"
    };
    constructor(props){
        super(props)
        this.state={
            formItemLayout : isEmptyObject(props.formItemLayout)&&props.formLayout=='horizontal'? {
                labelCol: { span:  Locale.current()=='zh'?4:6 },
                wrapperCol: { span: Locale.current()=='zh'?20:18 },
                labelAlign: 'left',
            }:props.formItemLayout , // 其他接收 如 vertical  垂直模式
        }
    };
    formRef = React.createRef();
    /**
     * 模拟接口
     * 提供父组件 调用获取所有数据
     * */
    handleOK = async() => {
        let res =  {}
        try {
            const values = await this.formRef.current.validateFields();
            let map = {}
            for(let key in values){
                if(!isEmpty(values[key]))map[key] = typeof values[key]=='string'?trim(values[key]):values[key];
            }
            const {options=[]} = this.props;
            const bankNos = options.filter(opt=>opt.type=="BankNo");
            bankNos.forEach(item=>{
                if(map[item.name]){
                    map[item.name] =  map[item.name].replace(/\s/g, '');
                }
            })
            res= {success:true,data: map};
        } catch (errorInfo) {
            res= {success:false}
        }
        return res
    };
    /**
     * 重置
     * */
    handleReset = () => {
        this.formRef.current.resetFields();
    }
    /***
     * 清除字段值 | 设置字段)
     */
    setField = (field='',value=undefined) =>{
        if(field){
            let obj = {};
            obj[field] = value;
            this.formRef.current.setFieldsValue(obj);
        }
    }
    // 输出 类型
    // getEnumClass(enumClass){
        // const list = __getDictMap(enumClass) || {};
        // const enumChildren = [];
        // if(!isEmptyObject(list)){
        //     for(let key in list){
        //         enumChildren.push(<Option key={key}>{list[key]}</Option>);
        //     }
        // }
        // const list =__getDictList(enumClass)|| [];
        // console.log(enumClass,"list",list);
        // const enumChildren = [];
        // if(list&&list.length>0){
        //     list.forEach(item=>enumChildren.push(<Option key={item.id}>{list[key]}</Option>));
        // }
        // return enumChildren;
    // }
    // 渲染 选项
    renderOptions(options=[],size,initialValues={}){
        const { formItemLayout, } = this.state;
        let optionsChildren = [];
        options.map((item,inx) => {
           if(item)optionsChildren.push(
                this.renderOptionType(item, formItemLayout,initialValues,size,inx)
            )
        })
        return optionsChildren;
    }
    // 输出 类型
    renderOptionType(item, style={},initialValues,size,inx){
        const formItemLayout = style?{...style}:{}
        const langShowText = item.cnTitleId?Lang({id:item.cnTitleId,default:item.cnTitle}):item.title||'';
        const langPlaceholderText = item.cnPlaceholderId&&item.cnPlaceholderId.constructor == Array ?
            (item.cnPlaceholderId&&item.cnPlaceholderId.length>1?[Lang({id:item.cnPlaceholderId[0],default:item.cnPlaceholder[0]}),Lang({id:item.cnPlaceholderId[1],default:item.cnPlaceholder[1]})]:item.title||Lang({id:"QingShuRu", default:"请输入"})):(item.cnPlaceholderId?Lang({id:item.cnPlaceholderId,default:item.cnPlaceholder}):item.title||Lang({id:"QingShuRu", default:"请输入"}));
        if(formItemLayout&&item.className){
            formItemLayout["className"] = item.className;
        }
        switch (item.type) {
            case 'BtnSelect':
                return (<FormItem name={item.name}
                                  label={item.hiddenLabel?'':(
                                      <span className="label-txt">{langShowText}</span>
                                  )}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                   <BtnSelect list={item.list} canClear={item.canClear} initValue={initialValues[item.name]} callBack={(value)=>item.callBack&&item.callBack(value)} />
                </FormItem>);
            case 'Enum':
                const enumList = item.enumList&&item.enumList.length>0?item.enumList:(__getDictList(item.enumClass)|| []);
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  hidden={item.hidden}
                                  label={langShowText}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText}]}>
                    <Select allowClear
                            placeholder={langPlaceholderText}
                            mode={item.mode||null}
                            onChange={(value,option )=>item.change?item.change(value,option):null}
                            disabled={item.disabled} >
                        {(enumList.length>0)?enumList.map((children,clKey)=>{return(<Option key={item.name+'s_'+clKey} id={children.id}
                                                                                            value={item.valueKey?(children[item.valueKey]+""):(children.code||children.id)}>{children.name}</Option>)}):null}

                    </Select>
                </FormItem>);
            case 'Number':
                const numConfig = item.numConfig? {...item.numConfig} : {}
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  hidden={item.hidden}
                                  label={langShowText}
                                  name={item.name}
                                  rules={item.pattern?[...item.pattern]:[
                                      { required:item.required? true:false, message: langPlaceholderText||langShowText }]
                                  }
                >
                   <InputNumber { ...numConfig} addonAfter={item.addonAfter} size={size} placeholder={langPlaceholderText} />
                </FormItem>);
            case 'Password':
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{pattern:item.pattern?item.pattern:/^([\w\W]*).{6,20}$/, message: item.patternMsg?item.patternMsg:Lang({id:'MiMaGuiZe2',default:'请输入6-20位字符'})},
                                  { required:item.required? true:false, whitespace:true,message: langPlaceholderText }]} >
                    <Input.Password size={size}
                                    placeholder={langPlaceholderText} disabled={item.disabled}
                    />
                </FormItem>);
            case 'AreaPhone': {/* 绑定手机 获取验证码 */}
                    let config = {
                        size:size
                    }
                    if(item.setCopyValue){
                        config["onChange"] = (e)=>this.setField(item.setCopyValue,e.target.value);
                    }
                    if(item.addonAfter){
                        config["addonAfter"] = item.addonAfter;
                    }
                    if(item.suffix){
                        config["suffix"] = item.suffix;
                    }
                return (<> <FormItem{ ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false,  pattern:'^[0-9]*$',message: langPlaceholderText||langShowText}]}>
                   <Input {...config}
                          placeholder={langPlaceholderText}
                          addonBefore={<TelephoneCode defaultItemCode={initialValues[item.nameTelephoneCode||"telCode"]}
                                                      onItemClicked={(data)=>this.setField(item.nameTelephoneCode||"telCode",data)}
                          />}
                    />
                </FormItem>
                <FormItem  key={(item.nameTelephoneCode||"telCode")+"_"+inx}  style={{display:"none"}}
                           name={item.nameTelephoneCode||"telCode"} >
                                <Input key={(item.nameTelephoneCode||"telCode")+"_i"+inx} style={{display:"none"}}   />
                </FormItem>
            </>);
            case 'Radio':
                if((!item.options||item.options.length==0)&&item.radioClass){
                    const list = __getDictList(item.radioClass) || [];
                    item.options = [];
                    list.forEach(dict=>{
                        item.options.push({
                            value: item.valueKey?dict[item.valueKey]:dict.code,
                            title:dict.name,
                        })
                    })
                }
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false, message:langPlaceholderText||langShowText }]}>
                    <Radio.Group disabled={item.disabled} onChange={(e)=>item.change?item.change(e.target):null} size={size}>
                        {item.options&&item.options.map((opt,rInx)=><Radio key={opt.value+"_"+rInx} value={opt.value+''}>{opt.title||__getServerLanguage(opt.cnTitleId)}</Radio>)}
                    </Radio.Group>
                </FormItem>);
            case 'RadioButton':
                if((!item.options||item.options.length==0)&&item.radioClass){
                    const list = __getDictList(item.radioClass) || [];
                    item.options = [];
                    list.forEach(dict=>{
                        item.options.push({
                            value: item.valueKey?dict[item.valueKey]:dict.code,
                            title:dict.name,
                        })
                    })
                }
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false, message:langPlaceholderText||langShowText }]}>
                    <Radio.Group disabled={item.disabled} onChange={(e)=>item.change?item.change(e.target):null} size={size}>
                        {item.options&&item.options.map((opt,rInx)=><Radio.Button key={opt.value+"_"+rInx}
                                                                                  value={opt.value+''}>{opt.title||__getServerLanguage(opt.cnTitleId)}</Radio.Button>)}
                    </Radio.Group>
                </FormItem>);
            case 'TextArea':
                let textAreaConf = {}
                if(item.maxLength){
                    textAreaConf["maxLength"] = item.maxLength;
                }
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false,whitespace:true, message: langPlaceholderText||langShowText}]}>
                    <TextArea {...textAreaConf} key={item.name+"_t"+inx}
                              size={size}
                              autoSize={{ minRows: item.minRows||3, maxRows: 6 }}
                              placeholder={langPlaceholderText} disabled={item.disabled} />
                </FormItem>);
            case 'SearchSelector': //搜索选择器
                const searchClass = item.searchClass||{};
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false,  message: langPlaceholderText||langShowText }]}>
                     <SearchSelector size={size} disabled={item.disabled}  key={item.name+"_ts"+inx}
                                     title={isEmpty(searchClass.searchTitle)?langShowText:searchClass.searchTitle}
                                     searchField={searchClass.searchField}
                                     initValue={item.value?(item.value+''):null}
                                     api={searchClass.api}
                                     hidden={item.hidden}
                                     field={searchClass.field}
                                     idField={searchClass.idField} />
                </FormItem>);
            case 'SearchSelect': //搜索下拉
                const searchClass2 = item.searchClass||{};
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false,  message: langPlaceholderText||langShowText }]}>
                        <CommonSelect placeholder={langPlaceholderText}
                                      api={searchClass2.api}
                                      size={size}
                                      precondition={searchClass2.precondition||{}}
                                      initFirstOne={searchClass2.initFirstOne||false}
                                      nameField={searchClass2.nameField}
                                      idField={searchClass2.idField} />
                    </FormItem>);
            case 'Select':
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText} name={item.name} rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                        <CommonSelect placeholder={langPlaceholderText}
                                      size={size}
                                      onOtherChange={(data)=>item.change?item.change(data):null}
                                      list={item.list||[]}
                                      initValue={item.value?(item.value+''):null}
                                      nameField={item.nameField}
                                      idField={item.idField} />
                    </FormItem>);
            case 'CountrySelect':
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText} name={item.name} rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                    <CommonSelect placeholder={langPlaceholderText}
                                  onOtherChange={(data)=>item.change?item.change(data):null}
                                  list={item.list||[]}
                                  size={size}
                                  type={"abbreviate"}
                                  initValue={item.value?(item.value+''):null}
                                  nameField={item.nameField}
                                  idField={item.idField} />
                </FormItem>);
            case 'UploadFileIcon':
                const fileList = item.value?[...item.value]:(initialValues[item.name]||'');
                return (<FormItem { ...formItemLayout}  key={item.name+"_"+inx}
                                  label={langShowText}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                   <UploadFileIcon accept={item.accept}
                                   key={item.name+"_i"+inx}
                                   initValue={fileList}
                                   topTips={item.topTips}
                                   typeUpload={item.typeUpload}
                                   maxCount={item.maxCount}
                                   fileSizeLimit={item.fileSizeLimit}/>
                </FormItem>);
            case 'UploadFile':
                return (<FormItem { ...formItemLayout} key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  className={'essaone-white-bg-form-item'}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                        <UploadFile size={size}
                            options={item.options}
                            disabled={item.disabled}
                            accept={item.accept}
                            api={item.api}
                            placeholder={item.cnPlaceholderId?Lang({id:item.cnPlaceholderId,default:item.cnPlaceholder}):""}
                            multiple={item.multiple}
                            maxCount={item.maxCount}
                            initValue={initialValues[item.name]||[]}
                            flagLimitType={item.flagLimitType} />
                </FormItem>);
            case 'UploadImage':
                const imageList = initialValues[item.name]||'';
                let newFormItemLayout = {...formItemLayout}
                if(langShowText) newFormItemLayout['label']=langShowText;
                return (<FormItem { ...newFormItemLayout} key={item.name+"_u"+inx}
                                  hidden={item.hidden}
                                  name={item.name}
                                  style={{ display:'block',flexFlow: 'nowrap'}}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                   <UploadImage size={size} accept={item.accept} initValue={imageList} maxCount={item.maxCount} styleUpload={item.styleUpload} styleName={item.styleName}/>
                </FormItem>);
            case 'ViewImage':
                const viewList = initialValues[item.name]||''
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_vi"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  style={{flexFlow: 'nowrap'}}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                    <ViewImage size={size} initValue={viewList} />
                </FormItem>);
            case 'Checkbox':
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_c"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}>
                        <Checkbox.Group size={size}
                            options={item.options}
                            disabled={item.disabled}
                        />
                </FormItem>);
            case 'Region':
                return (<Region required={item.required}
                                size={size}
                                className={item.className}
                                gutter={item.gutter}
                                key={item.name+"_r"+inx}
                                disabled={item.disabled}
                                formItemLayout={formItemLayout}
                                title={langShowText}
                                name={item.name}
                                initValue={initialValues}
                                clearSubRegion={(v)=>this.setField(v)}
                />)
            case 'TransitCity':
                return (<TransitCity required={item.required}
                                     size={size}
                                     key={item.name+"_t"+inx}
                                     formItemLayout={formItemLayout}
                                     title={langShowText}
                                     initValue={initialValues}
                                     clearSubRegion={(v)=>this.setField(v)}
                      />)
            case 'City':
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{  required:item.required? true:false, message: Lang({id:'QingXuanZeChengShi',default:'请选择城市'})} ]}>
                            {/*<Input size={size} placeholder={langPlaceholderText} disabled={item.disabled} style={{display:"none"}} />*/}
                        <City required={item.required}
                              size={size}
                              name={"cityComponent"}
                              langShowText={langShowText}
                              initValue={initialValues[item.name]}
                              onChangeCity={(v)=>this.setField(item.name,v)}  />
                    </FormItem>);
            case 'Email':
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{  required:item.required? true:false,whitespace:true,message: langPlaceholderText||langShowText},
                                      { type: 'email',message: Lang({id:'QingTianXieZhengQueDeDianZiYouXiang',default:'请填写正确的电子邮箱'})}
                                      ]}>
                   <Input size={size} placeholder={langPlaceholderText} disabled={item.disabled} />
                </FormItem>);
            case 'Category':
                return (<FormItem { ...formItemLayout}
                                  name={item.name}
                                  key={item.name+"_"+inx}
                                rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}
                                label={item.hiddenLabel?'':(
                                    <span className="label-txt">{langShowText}</span>
                                )}>
                                    <CategorySelector placeholder={<Lang id="QingXuanZeJingYingLeiMu">请选择经营类目</Lang>}
                                        initialValue={item.value||initialValues[item.name]}
                                        getCateUrl={item.getCateUrl}  />
                </FormItem>);
            case 'DateRangePicker':
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_"+inx}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  name={item.name}
                                  rules={[{ type: 'array', required:item.required? true:false,message: item.errMsg||langPlaceholderText||langShowText }]}>
                    <RangePicker size={size} disabled={item.disabled} placeholder={langPlaceholderText} />
                </FormItem>);
            case 'Date':
                return (<FormItem { ...formItemLayout}
                                  label={langShowText}
                                  hidden={item.hidden}
                                  key={item.name+"_"+inx}
                                  name={item.name}
                                  rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]} >
                     <DatePicker disabled={item.disabled} size={size}
                                 placeholder={langPlaceholderText}
                                 disabledDate={(currentDate)=>item.disabledDate?item.disabledDate(currentDate):""}
                                 // disabledDate={(current)=>this.disabledLessThanDate(current,item.disabledLessThanBeforeToday)}
                    />
                </FormItem>);
            case 'OnlyRender':
                return item.showTitle?<FormItem { ...formItemLayout}
                                                key={item.name+"_"+inx}
                                                name={item.name}
                                                rules={[{ required:item.required? true:false, message: langPlaceholderText||langShowText }]}
                                                label={langShowText}>
                    {item.onlyRender}
                </FormItem>:item.onlyRender;
            case 'Text':
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_"+inx}
                                  label={langShowText}>
                    {item.value||initialValues[item.name]}
                    {/*<Input value={item.value||initialValues[item.name]} className={'input-text'} disabled={true} />*/}
                </FormItem>);
            case 'BankNo':
                // 格式化银行卡号显示(每4位加空格)
                const formatBankNo = (value) => {
                    if (!value) return value;
                    // 先去除所有空格,再每4位添加一个空格
                    return value.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
                }
                const bankConfig = {
                    size:size,
                    placeholder:langPlaceholderText,
                    disabled:item.disabled,
                    onChange: (e) => {
                        // 格式化显示值
                        const rawValue = e.target.value.replace(/\s/g, ''); // 去除空格
                        const formatted = formatBankNo(rawValue);
                        // 更新显示值
                        const currentValues = this.formRef.current.getFieldsValue();
                        currentValues[item.name] = formatted;
                        this.formRef.current.setFieldsValue(currentValues);
                    }
                }
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_"+inx}
                                  hidden={item.hidden}
                                  label={langShowText}
                                  name={item.name}
                                  rules={[{
                                      required:item.required? true:false,
                                      message: langPlaceholderText||langShowText,
                                  },{
                                      pattern: /^[\d\s]{16,23}$/,//13至19位数字，允许空格间隔
                                      message: Lang({id:"YinXingKaHaoGeShiYouWu",default:"银行卡号格式有误"})
                                  }]}>
                    <Input {...bankConfig} />
                </FormItem>);
            default:
                let defaultConfig = {
                    size:size,
                    placeholder:langPlaceholderText,
                    disabled:item.disabled
                }
                if(item.maxLength){
                    defaultConfig["maxLength"] = item.maxLength;
                }
                let defaultRule = {
                    required:item.required? true:false,
                    message: langPlaceholderText||langShowText
                }
                if(item.whitespace){
                    defaultRule['whitespace']=item.whitespace;
                }
                return (<FormItem { ...formItemLayout}
                                  key={item.name+"_"+inx}
                                  hidden={item.hidden}
                                  label={langShowText}
                                  name={item.name}
                                  rules={item.pattern?[...item.pattern]:[defaultRule]
                                  }>
                 <Input {...defaultConfig} />
                </FormItem>);
        }
    }
    //控制时间 可用范围
    // disabledLessThanDate(current,disabledLessThanBeforeToday) {
    //     return disabledLessThanBeforeToday?current < dayjs().subtract(1, 'days'):null;
    // }
    // 关闭操作
    handleCancel = () => {
        this.props.handleCancel()
    }
    // 加载
    componentDidMount() {
        if(this.props.onRef)  this.props.onRef(this);
    };
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const { options,initialValues,formLayout,size,className,name} = this.props;
        return (
            <div className={"autoRow"}>
                <Form ref={this.formRef}
                      className={className}
                      onFinish={this.handleOK}
                      layout={formLayout}
                      name={name}
                      initialValues={initialValues}
                      colon={false}>
                    {options&&this.renderOptions(options,size,initialValues)}
                </Form>
        </div>);
    }
}
export default FormFormat
